export const BET_TRACKING_TYPE = 'bet_tracking';

export const BET_TRACKING_THRESHOLD = 'threshold';
export const BET_TRACKING_RANGE = 'range';
